import { render, staticRenderFns } from "./ReelDesktopOverlay.vue?vue&type=template&id=65b3504e&scoped=true"
import script from "./ReelDesktopOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReelDesktopOverlay.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ReelDesktopOverlay.vue?vue&type=style&index=0&id=65b3504e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b3504e",
  null
  
)

export default component.exports